import gql from "graphql-tag";
import { useTesQuery } from "./useTesQuery";

const GET_TAKEBACK = gql`
  query GetTakeback($id: String!) {
    takeback(id: $id) {
      updated_at
      type_name
      timestamp
      source
      takeback_processing_history_list {
        eventId
        id
        parent_status
        processed_at
        status
        takeback_id
        updated_at
      }
      shipping_tracking_id
      shipping_provider_id
      quantity
      product_id
      last_processed
      id
      eventId
      deleted_at
      data
      customer_id
      created_at
      customer_id_belongsTo {
        id
        name
        last_name
        email
        address_line1
        address_line2
        city
        state
        postal_code
        country
        phone
      }
      payments_list {
        created_at
        id
        takeback_id
        type
        updated_at
        payments_metadata_list {
          created_at
          id
          key
          payment_id
          updated_at
          value
        }
      }
    }
  }
`;

export const useGetTakeback = (takebackId, options = {}) => {
  return useTesQuery(
    GET_TAKEBACK,
    { id: takebackId },
    {
      enabled: Boolean(takebackId),
      ...options,
    }
  );
};
